import Icon from "../../images/icons/loading.gif";

const LoaderIcon = ({ ...rest }) => {
	return <img src={Icon} {...rest} />;
};

export default LoaderIcon;
